<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 content-class="round-2xl")
  v-card
    v-card-title.pa-4
      v-row(no-gutters align="center")
        v-col(cols="10" offset="1")
          div.text-xl.font-bold.neutral700--text.text-center {{ $t('mark_sent_pending') }}
        v-col(cols="1" align="right")
          v-btn.ml-n3(text icon @click="closeDialog")
            v-icon(color="neutral700" :size="24") mdi-close
    v-divider
    v-card-text(:class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'pa-8'")
      div.text-lg.font-medium.neutral700--text {{ $t('mark_sent_pending_confirmation') }}
      div.text-md.neutral700--text.mt-4 {{ $t('mark_sent_pending_confirmation_desc') }}
      div.text-md.neutral700--text.mt-2 {{ $t('click_confirm_to_proceed') }}
    v-divider
    v-card-actions.py-4(:class="$vuetify.breakpoint.xsOnly ? 'px-4' : 'px-8'")
      v-btn.button-md.neutral700--text.px-0(@click="closeDialog" text) {{ $t('cancel') }}
      v-spacer
      v-btn.button-md(@click="deleteItem" :loading="isLoading" color="danger500" depressed dark) {{ $t('confirm') }}
</template>

<script>
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'MarkSentPending',
  props: ['open', 'selectedAppointment'],
  data: () => ({
    isLoading: false
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany'
    }),
    showDialog: {
      get() {
        return this.open
      },
      set(newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    ...mapActions(['showMessage']),
    deleteItem() {
      this.isLoading = true
      this.$axios.delete(`/leads/${this.selectedAppointment.lead.pid}/taggings/contacted`)
        .then(() => {
          this.closeResetDialog()
        })
        .catch(() => {
          this.showMessage(['error', this.$t('error_message.unable_to_complete_request')])
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    closeResetDialog () {
      this.showDialog = false
      this.$emit('reset')
    },
    closeDialog () {
      this.showDialog = false
      this.$emit('closed')
    },
  }
}
</script>